import { render, staticRenderFns } from "./reporte.vue?vue&type=template&id=16676dee&scoped=true&"
import script from "./reporte.vue?vue&type=script&lang=js&"
export * from "./reporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16676dee",
  null
  
)

export default component.exports